export default __webpack_public_path__ + "static/media/en.d7ef535e.md";